import { Button, OdinIcon } from '@myosh/odin-components';
import React from 'react';

interface FormBuilderAddButtonProps {
  onClick: () => void;
  label: string;
}
const FormBuilderAddButton = ({ onClick, label }: FormBuilderAddButtonProps) => {
  return (
    <div className="grid place-content-center">
      <Button type="text" onClick={onClick}>
        <OdinIcon icon="Plus" />
        {label}
      </Button>
    </div>
  );
};

export default React.memo(FormBuilderAddButton);
